import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: any = {
  fullName:'',
}
const userSlice = createSlice({
    name:'user',
    initialState,
    reducers:{
        updateUser:(state, action: PayloadAction<any>)=>{
            console.log('action',action);
            return action.payload || null
        }
    }
})

export const { updateUser } = userSlice.actions
export default userSlice.reducer